<template>
  <div @click.shift="selectItemsRange">
    <!--    <div class="tooltip">Hover over me-->
    <!--      <span class="tooltiptext">Tooltip text</span>-->
    <!--    </div>-->

    <div class="mass-operations" :style="massOperationsDisplayStyle">
      <div class="mass-operations-block">
        <span>Działania masowe:</span>
        <button
          id="mass-assign-seller-offerss-btn"
          class="btn btn-info mass-operations-btn"
          :disabled="!itemsMassActionsEnabled"
        >
          Jakaś masowa akcja
        </button>
      </div>
    </div>

    <!--    Content table-->
    <table
      class="table table-hover table-bordered table-slim-style"
      :style="tableOpacityStyle"
    >
      <thead>
        <tr>
          <td>
            <div
              class="btn btn-outline-info search-start-block"
              @click="searchWithFilters"
            >
              <i class="fas fa-search" />
            </div>
          </td>
          <td>
            <div class="filter-id-block">
              <div>
                Od:<input
                  type="number"
                  class="filter-id-input"
                  v-model="idFrom"
                />
              </div>
              <div>
                Do:<input
                  type="number"
                  class="filter-id-input"
                  v-model="idTo"
                />
              </div>
            </div>
          </td>
          <td>
            <div class="filter-bloz-block">
              <div>
                <input
                  type="text"
                  class="filter-bloz-input"
                  v-model="filterSettingsObject.bloz"
                />
              </div>
            </div>
          </td>
          <td>
            <div class="filter-product-id-suppliers-stock-block">
              <div>
                <input
                  type="text"
                  class="filter-product-id-suppliers-stock-input"
                  v-model="productIdInSuppliersStock"
                />
              </div>
            </div>
          </td>
          <td>
            <div class="filter-name-block">
              <div>
                <input
                  type="text"
                  class="filter-name-input"
                  v-model="filterSettingsObject.name"
                />
              </div>
            </div>
          </td>
          <td>
            <div class="filter-stock-quantity-block">
              <div>
                Od:<input
                  type="text"
                  class="filter-stock-quantity-input"
                  v-model="stockMultiplierInclFrom"
                />
              </div>
              <div>
                Do:<input
                  type="text"
                  class="filter-stock-quantity-input"
                  v-model="stockMultiplierInclTo"
                />
              </div>
            </div>
          </td>
          <td>
            <div class="filter-purchase-price-block">
              <div>
                Od:<input
                  type="text"
                  class="filter-purchase-price-input"
                  v-model="purchasePriceFrom"
                />
              </div>
              <div>
                Do:<input
                  type="text"
                  class="filter-purchase-price-input"
                  v-model="purchasePriceTo"
                />
              </div>
            </div>
          </td>
          <td>
            <div class="filter-promotional-price-block">
              <div>
                Od:<input
                  type="text"
                  class="filter-promotional-price-input"
                  v-model="promotionalPriceFrom"
                />
              </div>
              <div>
                Do:<input
                  type="text"
                  class="filter-promotional-price-input"
                  v-model="promotionalPriceTo"
                />
              </div>
            </div>
          </td>
          <td>
            <div class="filter-ean-block">
              <div>
                <input
                  type="text"
                  class="filter-ean-input"
                  v-model="filterSettingsObject.ean"
                />
              </div>
            </div>
          </td>
          <td>
            <div class="filter-expiration-date-block">
              <div>
                <input
                  type="date"
                  class="filter-expiration-date-input"
                  v-model="expirationDateFilter"
                />
              </div>
            </div>
          </td>
          <td>
            <div class="filter-stock-days-block">
              <div>
                Od:<input
                  type="text"
                  class="filter-stock-days-input"
                  v-model="daysOnStockFrom"
                />
              </div>
              <div>
                Do:<input
                  type="text"
                  class="filter-stock-days-input"
                  v-model="daysOnStockTo"
                />
              </div>
            </div>
          </td>
          <td>
            <div class="filter-supplier-block">
              <div>
                <input
                  type="text"
                  class="filter-supplier-input"
                  v-model="supplierId"
                />
              </div>
            </div>
          </td>
          <td>
            <div class="filter-supplier-type-block">
              <div>
                <select
                  class="filter-supplier-type-input"
                  v-model="supplierTypeFilter"
                >
                  <option>Wszystkie</option>
                  <option>Apteka</option>
                  <option>Hurtownia</option>
                </select>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <label class="form-checkbox">
              <input
                type="checkbox"
                v-model="selectAllItems"
                @change="selectItem"
              />
              <i class="form-icon"></i>
            </label>
          </th>
          <th>
            Id
            <i class="fas fa-sort" @click="sortBy('id')" />
          </th>
          <th>
            Bloz
            <i class="fas fa-sort" @click="sortBy('bloz')" />
          </th>
          <th>
            Nrtow
            <i class="fas fa-sort"
              @click="sortBy('productIdInSuppliersStock')"
            />
          </th>
          <th>
            Nazwa
            <i class="fas fa-sort" @click="sortBy('name')" />
          </th>
          <th>
            Ilość
            <i class="fas fa-sort"
              @click="sortBy('stockMultiplierIncl')"
            />
          </th>
          <th>
            Cena netto
            <i class="fas fa-sort"
              @click="sortBy('purchasePriceTaxExclDiscountInclMultiplierIncl')"
            />
          </th>
          <th>
            Promocja
            <i class="fas fa-sort"
              @click="sortBy('promotionalPriceTaxExclMultiplierIncl')"
            />
          </th>
          <th>
            Ean
            <i class="fas fa-sort" @click="sortBy('eanCode')" />
          </th>
          <th>
            D.W.
            <i class="fas fa-sort"
              @click="sortBy('expirationDateEpochSeconds')"
            />
          </th>
          <th>
            W magazynie
            <i class="fas fa-sort"
              @click="sortBy('stockingPeriodInDays')"
            />
          </th>
          <th>
            Dostawca
            <i class="fas fa-sort" @click="sortBy('supplierId')" />
          </th>
          <th>
            Typ dostawcy
            <i class="fas fa-sort" @click="sortBy('supplierType')" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="offer in ordersModule.getOffers"
          :key="offer.id"
          :style="getOfferDateStyle(offer.addingDateEpochSeconds)"
        >
          <td>
            <label class="form-checkbox">
              <input
                type="checkbox"
                :value="offer.id"
                v-model="selectedItems"
              />
              <i class="form-icon"></i>
            </label>
          </td>

          <div class="tooltip">
            <td>{{ offer.id }}</td>
            <span class="tooltiptext">{{
              getOfferCreationDate(offer.addingDateEpochSeconds)
            }}</span>
          </div>
          <td>{{ offer.bloz }}</td>
          <td>{{ offer.productIdInSuppliersStock }}</td>
          <div class="tooltip">
            <td>{{ getTrimName(offer.name) }}</td>
            <span class="tooltiptext">{{ offer.name }}</span>
          </div>
          <td>{{ getRoundedValue(offer.stockMultiplierIncl) }}</td>
          <td>
            {{
              getRoundedValue(
                offer.purchasePriceTaxExclDiscountInclMultiplierIncl
              )
            }}
          </td>
          <td>
            {{ getRoundedValue(offer.promotionalPriceTaxExclMultiplierIncl) }}
          </td>
          <td>{{ offer.eanCode }}</td>
          <td>{{ getDateOfEpoch(offer.expirationDateEpochSeconds) }}</td>
          <td>{{ offer.stockingPeriodInDays }}</td>
          <td>{{ offer.supplierId }}</td>
          <td>{{ offer.supplierType }}</td>
        </tr>
      </tbody>
    </table>
    <PaginationComponent
      :pagesCount="ordersModule.getOrdersManagerOffersPagesCount"
      prefix="offers_"
      getItemsPagingMethodName="ordersManagerModule/httpGetOrdersManagerOffersPaging"
      :filterSettingsPayload="filterSettingsObject"
      setItemsMethodName="ordersManagerModule/setOrdersManagerOffers"
      @currentPageChanged="setCurrentPage($event)"
    />
  </div>
</template>
<script>
import PaginationComponent from "@/components/widgets/PaginationComponent.vue";
import {settingsHelperFunctions} from "@/helpers/settingsHelper.js";
import {log} from "@/state/pinia/log";
import {useOrdersManagerModule} from "@/state/pinia/ordersManagerModule";

export default {
  name: "OrdersManagerOffersList",
  props: {},
  directives: {},
  components: {
    PaginationComponent
  },
  data() {
    return {
      buttonsEnabled: true,
      tableOpacityStyle: "opacity:1;",
      selectedItems: [],
      selectAllItems: false,
      itemsMassActionsEnabled: false,
      displayWarningMessage: false,
      warningMessage: "",
      expiredOfferStyle: { background: "#ffa5007d" },
      upToDateOfferStyle: { background: "#fff" },
      massOperationsDisplayStyle: {
        visibility: "hidden",
        opacity: "0",
        height: "0",
        transition:
          "height 1s linear 300ms, opacity 100ms linear 100ms,visibility 100ms linear 100ms",
      },
      sortingDirection: "ASC",
      currentPage: 0,
      filterSettingsObject: {
        idFrom: 0,
        idTo: 0,
        bloz: "",
        productIdInSuppliersStock: 0,
        name: "",
        stockMultiplierInclFrom: 0.0,
        stockMultiplierInclTo: 0.0,
        purchasePriceFrom: 0.0,
        purchasePriceTo: 0.0,
        promotionalPriceFrom: 0.0,
        promotionalPriceTo: 0.0,
        ean: "",
        expirationDate: null,
        daysOnStockFrom: 0,
        daysOnStockTo: 0,
        supplierId: 0,
        supplierType: "",
      },
    };
  },
  computed: {
    ordersModule(){
      return useOrdersManagerModule();
    },

    idFrom: {
      //getter
      get() {
        if (this.filterSettingsObject.idFrom === 0) {
          return "";
        }
        return this.filterSettingsObject.idFrom.toString();
      },
      // setter
      set(newValue) {
        if (this.valueIsNotInt(newValue)) {
          this.filterSettingsObject.idFrom = 0;
        } else {
          this.filterSettingsObject.idFrom = parseInt(newValue);
        }
      },
    },

    idTo: {
      //getter
      get() {
        if (this.filterSettingsObject.idTo === 0) {
          return "";
        }
        return this.filterSettingsObject.idTo.toString();
      },
      // setter
      set(newValue) {
        if (this.valueIsNotInt(newValue)) {
          this.filterSettingsObject.idTo = 0;
        } else {
          this.filterSettingsObject.idTo = parseInt(newValue);
        }
      },
    },

    productIdInSuppliersStock: {
      //getter
      get() {
        if (this.filterSettingsObject.productIdInSuppliersStock === 0) {
          return "";
        }
        return this.filterSettingsObject.productIdInSuppliersStock.toString();
      },
      // setter
      set(newValue) {
        if (this.valueIsNotInt(newValue)) {
          this.filterSettingsObject.productIdInSuppliersStock = 0;
        } else {
          this.filterSettingsObject.productIdInSuppliersStock =
            parseInt(newValue);
        }
      },
    },

    daysOnStockFrom: {
      //getter
      get() {
        if (this.filterSettingsObject.daysOnStockFrom === 0) {
          return "";
        }
        return this.filterSettingsObject.daysOnStockFrom.toString();
      },
      // setter
      set(newValue) {
        if (this.valueIsNotInt(newValue)) {
          this.filterSettingsObject.daysOnStockFrom = 0;
        } else {
          this.filterSettingsObject.daysOnStockFrom = parseInt(newValue);
        }
      },
    },

    daysOnStockTo: {
      //getter
      get() {
        if (this.filterSettingsObject.daysOnStockTo === 0) {
          return "";
        }
        return this.filterSettingsObject.daysOnStockTo.toString();
      },
      // setter
      set(newValue) {
        if (this.valueIsNotInt(newValue)) {
          this.filterSettingsObject.daysOnStockTo = 0;
        } else {
          this.filterSettingsObject.daysOnStockTo = parseInt(newValue);
        }
      },
    },

    supplierId: {
      //getter
      get() {
        if (this.filterSettingsObject.supplierId === 0) {
          return "";
        }
        return this.filterSettingsObject.supplierId.toString();
      },
      // setter
      set(newValue) {
        if (this.valueIsNotInt(newValue)) {
          this.filterSettingsObject.supplierId = 0;
        } else {
          this.filterSettingsObject.supplierId = parseInt(newValue);
        }
      },
    },

    purchasePriceFrom: {
      //getter
      get() {
        if (this.filterSettingsObject.purchasePriceFrom === 0.0) {
          return "";
        }
        return this.filterSettingsObject.purchasePriceFrom.toString();
      },
      // setter
      set(newValue) {
        if (this.valueIsNotDouble(newValue)) {
          this.filterSettingsObject.purchasePriceFrom = 0.0;
        } else {
          this.filterSettingsObject.purchasePriceFrom = parseFloat(newValue);
        }
      },
    },

    promotionalPriceFrom: {
      //getter
      get() {
        if (this.filterSettingsObject.promotionalPriceFrom === 0.0) {
          return "";
        }
        return this.filterSettingsObject.promotionalPriceFrom.toString();
      },
      // setter
      set(newValue) {
        if (this.valueIsNotDouble(newValue)) {
          this.filterSettingsObject.promotionalPriceFrom = 0.0;
        } else {
          this.filterSettingsObject.promotionalPriceFrom = parseFloat(newValue);
        }
      },
    },

    purchasePriceTo: {
      //getter
      get() {
        if (this.filterSettingsObject.purchasePriceTo === 0.0) {
          return "";
        }
        return this.filterSettingsObject.purchasePriceTo.toString();
      },
      // setter
      set(newValue) {
        if (this.valueIsNotDouble(newValue)) {
          this.filterSettingsObject.purchasePriceTo = 0.0;
        } else {
          this.filterSettingsObject.purchasePriceTo = parseFloat(newValue);
        }
      },
    },

    promotionalPriceTo: {
      //getter
      get() {
        if (this.filterSettingsObject.promotionalPriceTo === 0.0) {
          return "";
        }
        return this.filterSettingsObject.promotionalPriceTo.toString();
      },
      // setter
      set(newValue) {
        if (this.valueIsNotDouble(newValue)) {
          this.filterSettingsObject.promotionalPriceTo = 0.0;
        } else {
          this.filterSettingsObject.promotionalPriceTo = parseFloat(newValue);
        }
      },
    },

    stockMultiplierInclFrom: {
      //getter
      get() {
        if (this.filterSettingsObject.stockMultiplierInclFrom === 0.0) {
          return "";
        }
        return this.filterSettingsObject.stockMultiplierInclFrom.toString();
      },
      // setter
      set(newValue) {
        if (this.valueIsNotDouble(newValue)) {
          this.filterSettingsObject.stockMultiplierInclFrom = 0.0;
        } else {
          this.filterSettingsObject.stockMultiplierInclFrom =
            parseFloat(newValue);
        }
      },
    },
    stockMultiplierInclTo: {
      //getter
      get() {
        if (this.filterSettingsObject.stockMultiplierInclTo === 0.0) {
          return "";
        }
        return this.filterSettingsObject.stockMultiplierInclTo.toString();
      },
      // setter
      set(newValue) {
        if (this.valueIsNotDouble(newValue)) {
          this.filterSettingsObject.stockMultiplierInclTo = 0.0;
        } else {
          this.filterSettingsObject.stockMultiplierInclTo =
            parseFloat(newValue);
        }
      },
    },

    expirationDateFilter: {
      //getter
      get() {
        if (
          this.filterSettingsObject.expirationDate &&
          this.filterSettingsObject.expirationDate.length === 3
        ) {
          var monthValue = "";
          if (this.filterSettingsObject.expirationDate[1] > 9) {
            monthValue = this.filterSettingsObject.expirationDate[1];
          } else {
            monthValue = "0" + this.filterSettingsObject.expirationDate[1];
          }

          var dayValue = "";
          if (this.filterSettingsObject.expirationDate[2] > 9) {
            dayValue = this.filterSettingsObject.expirationDate[2];
          } else {
            dayValue = "0" + this.filterSettingsObject.expirationDate[2];
          }

          return (
            this.filterSettingsObject.expirationDate[0] +
            "-" +
            monthValue +
            "-" +
            dayValue
          );
        }
        log.log("this.filterSettingsObject.expirationDate");
        log.log(this.filterSettingsObject.expirationDate);
        return this.filterSettingsObject.expirationDate;
      },
      // setter
      set(newValue) {
        log.log("newValue");
        log.log(newValue);
        const dateElements = newValue.split("-");
        if (this.filterSettingsObject.expirationDate) {
          this.filterSettingsObject.expirationDate[0] = parseInt(
            dateElements[0]
          );
          this.filterSettingsObject.expirationDate[1] = parseInt(
            dateElements[1]
          );
          this.filterSettingsObject.expirationDate[2] = parseInt(
            dateElements[2]
          );
        } else {
          this.filterSettingsObject.expirationDate = [];
          this.filterSettingsObject.expirationDate.push(
            parseInt(dateElements[0])
          );
          this.filterSettingsObject.expirationDate.push(
            parseInt(dateElements[1])
          );
          this.filterSettingsObject.expirationDate.push(
            parseInt(dateElements[2])
          );
        }
      },
    },

    supplierTypeFilter: {
      //getter
      get() {
        if (this.filterSettingsObject.supplierType === "DRUGSTORE") {
          return "Apteka";
        } else if (this.filterSettingsObject.supplierType === "WHOLESALER") {
          return "Hurtownia";
        } else {
          return "Wszystkie";
        }
      },
      // setter
      set(newValue) {
        if (newValue === "Apteka") {
          this.filterSettingsObject.supplierType = "DRUGSTORE";
        } else if (newValue === "Hurtownia") {
          this.filterSettingsObject.supplierType = "WHOLESALER";
        } else {
          this.filterSettingsObject.supplierType = "";
        }
      },
    },
  },
  watch: {
    selectedItems: {
      handler() {
        this.toggleItemsMassOperationsButtons();
      },
      deep: true,
    },
  },
  methods: {

    ...settingsHelperFunctions,
    getOfferCreationDate(offerDateEpochSeconds) {
      if (offerDateEpochSeconds && offerDateEpochSeconds > 0) {
        var date = new Date(0); // The 0 sets the date to the epoch
        date.setUTCSeconds(offerDateEpochSeconds);
        var monthValue = date.getMonth() + 1;
        return (
          "Data oferty: " +
          date.getFullYear() +
          "." +
          monthValue +
          "." +
          date.getDate()
        );
      } else {
        return "Brak daty oferty";
      }
    },
    getOfferDateStyle(offerDateEpochSeconds) {
      if (offerDateEpochSeconds && offerDateEpochSeconds > 0) {
        var now = new Date();
        var dateLimit = new Date();
        dateLimit.setDate(now.getDate() - 3);

        var date = new Date(0); // The 0 sets the date to the epoch
        date.setUTCSeconds(offerDateEpochSeconds);
        if (date < dateLimit) {
          return this.expiredOfferStyle;
        } else {
          return this.upToDateOfferStyle;
        }
      } else {
        return this.expiredOfferStyle;
      }
    },

    getDateOfEpoch(epochSeconds) {
      if (epochSeconds && epochSeconds > 0) {
        var date = new Date(0); // The 0 sets the date to the epoch
        date.setUTCSeconds(epochSeconds);
        var monthValue = date.getMonth() + 1;
        return date.getFullYear() + "." + monthValue + "." + date.getDate();
      } else {
        return "";
      }
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    sortBy(sortingKeyValue) {
      this.toggleSortingDirection();
      this.ordersModule.setOrdersManagerOffers([]);
      this.currentPage = 0;
      var requestPayload = {
        currentPage: this.currentPage,
        filterSettingsObject: this.filterSettingsObject,
        sortingKey: sortingKeyValue,
        sortingDirection: this.sortingDirection,
      };
      this.ordersModule.httpGetOrdersManagerOffersPaging(requestPayload);
    },
    searchWithFilters() {
      this.ordersModule.setOrdersManagerOffers([]);
      this.currentPage = 0;
      var requestPayload = {
        currentPage: this.currentPage,
        filterSettingsObject: this.filterSettingsObject,
      };
      this.ordersModule.httpGetOrdersManagerOffersPaging(requestPayload);
    },
    setCurrentPage(page) {
      this.currentPage = page;
    },
    selectItem() {
      this.selectedItems = [];
      if (this.selectAllItems) {
        for (let i in this.ordersModule.getOffers) {
          this.selectedItems.push(this.ordersModule.getOffers[i].id);
        }
      }
      this.toggleItemsMassOperationsButtons();
    },
    toggleItemsMassOperationsButtons() {
      if (this.selectedItems.length > 0) {
        this.itemsMassActionsEnabled = true;
        this.massOperationsDisplayStyle = {
          visibility: "visible",
          opacity: "1",
          height: "50px",
          transition:
            "height 200ms linear 100ms, opacity 1s linear 300ms,visibility 1s linear 300ms",
        };
      } else {
        this.itemsMassActionsEnabled = false;
        this.massOperationsDisplayStyle = {
          visibility: "hidden",
          opacity: "0",
          height: "0",
          transition:
            "height 1s linear 300ms, opacity 100ms linear 100ms,visibility 100ms linear 100ms",
        };
      }
    },

    selectItemsRange() {
      log.log("Selecting items in range");
      //TODO selecting items in range with shift key
    },
  },
  created() {
    this.ordersModule.setOrdersManagerOffers([]);
    var requestPayload = {
      currentPage: this.currentPage,
      filterSettingsObject: this.filterSettingsObject,
    };
    this.ordersModule.httpGetOrdersManagerOffersPaging(requestPayload);
  },
};
</script>

<style scoped>
.mass-operations {
  display: block;
  margin-bottom: 10px;
  padding: 8px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  height: 0;
  opacity: 0;
  visibility: hidden;
}

.mass-operations-btn {
  margin-left: 5px !important;
  font-size: 0.9em !important;
}

.mass-operations-block {
  display: block;
  position: relative;
}

.filter-id-input {
  width: 45px;
  margin-left: 10px;
  margin-bottom: 2px;
  font-size: 0.9em;
  font-weight: bold;
}

.filter-id-block {
  font-size: 0.9em;
}

.filter-bloz-input {
  width: 45px;
  margin-left: 10px;
  margin-bottom: 15px;
  font-size: 0.9em;
  font-weight: bold;
}

.filter-bloz-block {
  vertical-align: middle;
  display: table-cell;
  font-size: 0.9em;
}

.filter-product-id-suppliers-stock-input {
  width: 45px;
  margin-left: 10px;
  margin-bottom: 15px;
  font-size: 0.9em;
  font-weight: bold;
}

.filter-product-id-suppliers-stock-block {
  vertical-align: middle;
  display: table-cell;
  font-size: 0.9em;
}

.filter-name-input {
  width: 300px;
  margin-left: 10px;
  margin-bottom: 15px;
  font-size: 0.9em;
  font-weight: bold;
}

.filter-name-block {
  vertical-align: middle;
  display: table-cell;
  font-size: 0.9em;
}

.filter-purchase-price-input {
  width: 45px;
  margin-left: 10px;
  margin-bottom: 2px;
  font-size: 0.9em;
  font-weight: bold;
}

.filter-purchase-price-block {
  font-size: 0.9em;
}

.filter-promotional-price-input {
  width: 45px;
  margin-left: 10px;
  margin-bottom: 2px;
  font-size: 0.9em;
  font-weight: bold;
}

.filter-promotional-price-block {
  font-size: 0.9em;
}

.filter-stock-quantity-input {
  width: 45px;
  margin-left: 10px;
  margin-bottom: 2px;
  font-size: 0.9em;
  font-weight: bold;
}

.filter-stock-quantity-block {
  font-size: 0.9em;
}

.filter-ean-input {
  width: 100px;
  margin-left: 10px;
  margin-bottom: 15px;
  font-size: 0.9em;
  font-weight: bold;
}

.filter-ean-block {
  vertical-align: middle;
  display: table-cell;
  font-size: 0.9em;
}

.filter-expiration-date-input {
  width: 110px;
  margin-left: 10px;
  margin-bottom: 15px;
  font-size: 0.9em;
  font-weight: bold;
}

.filter-expiration-date-block {
  vertical-align: middle;
  display: table-cell;
  font-size: 0.9em;
}

.filter-stock-days-input {
  width: 45px;
  margin-left: 10px;
  margin-bottom: 2px;
  font-size: 0.9em;
  font-weight: bold;
}

.filter-stock-days-block {
  font-size: 0.9em;
}

.filter-supplier-input {
  width: 45px;
  margin-left: 10px;
  margin-bottom: 15px;
  font-size: 0.9em;
  font-weight: bold;
}

.filter-supplier-block {
  vertical-align: middle;
  display: table-cell;
  font-size: 0.9em;
}

.filter-supplier-type-input {
  width: 80px;
  margin-left: 10px;
  margin-bottom: 15px;
  font-size: 0.9em;
  font-weight: bold;
}

.filter-supplier-type-block {
  vertical-align: middle;
  display: table-cell;
  font-size: 0.9em;
}

.search-start-block {
  margin-bottom: 6px;
}

/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  opacity: 1;
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
</style>
